import React from 'react';
import { CRM_COLORS, PAGE_MAX_WIDTH } from '../theme/crmColors';
import { useIsMobile } from '../hooks/useIsMobile';
import { Box } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import Authentication from '../components/auth/Authentication';
import AvatarCreationHistory from '../components/dashboard/AvatarCreationHistory';
import IntegratedHeader from '../components/header/IntegratedHeader';
import { CustomReducerState } from '../redux/reducers';
import { User } from '../utils/types';
import { dashboard, redirect_to_dashboard } from './paths';

const DashboardPage = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();
    const isMobile = useIsMobile();

    return (
        <Authentication redirectTo={redirect_to_dashboard}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        gridTemplateColumns: 'minmax(0, 1fr)',
                        overflowX: 'hidden',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={dashboard}
                        eyebrow={translate('app.headers.eyebrow.overview')}
                        title={translate('app.dashboard.title')}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minWidth: 0,
                            minHeight: 0,
                        }}
                    >
                        <Box
                            style={{
                                width: '100%',
                                maxWidth: PAGE_MAX_WIDTH,
                                margin: '0 auto',
                                padding: isMobile ? 8 : 24,
                                boxSizing: 'border-box',
                            }}
                        >
                            <AvatarCreationHistory />
                        </Box>
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default DashboardPage;
